import CalendarProcessingOptions from 'owa-service/lib/contract/CalendarProcessingOptions';
import getCalendarProcessingOperation from 'owa-service/lib/operation/getCalendarProcessingOperation';
import GetCalendarProcessingResponse from 'owa-service/lib/contract/GetCalendarProcessingResponse';

/**
 * Service call to get calendar processing options
 */

export default async function getCalendarProcessingOptions(): Promise<CalendarProcessingOptions> {
    let response: GetCalendarProcessingResponse = await getCalendarProcessingOperation();
    if (response.ErrorCode) {
        return null;
    } else {
        return response.Options;
    }
}
